<template>
  <label class="text-xs font-medium text-gray-500">
    {{ title }}
    <slot name="content"></slot>
  </label>
</template>

<script>
export default {
  name: "VLabel",

  props: {
    title: { type: String, default: "" },
  },
}
</script>

<style scoped></style>
